import { computed, ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cad1f79c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left_container_top d-flex a-center"
};
const _hoisted_2 = {
  style: {
    "height": "100%"
  }
};
const _hoisted_3 = {
  class: "imgOneWrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "menu_inner_top row"
};
const _hoisted_6 = {
  class: "avatarImgWrapper"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "phoneWrapper flex-1"
};
import robote from '@/assets/images/leftSlide/robote.png';
import { useStore } from 'vuex';
import roleHooks from '@/hooks/roleHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'slideHeader',
  emits: ['close'],
  setup(__props, {
    emit: emits
  }) {
    const store = useStore();
    const token = computed(() => store.state.userInfo.token);
    const wwToken = computed(() => store.state.userInfo.wwToken);
    const phone = computed(() => store.state.userInfo.phone);
    const {
      setIsShowLeft
    } = roleHooks();
    const dropdown = ref(null);
    const close = () => {
      setIsShowLeft(false);
    };
    const logout = () => {
      var _dropdown$value;
      (_dropdown$value = dropdown.value) === null || _dropdown$value === void 0 ? void 0 : _dropdown$value.handleClose();
      store.commit('userInfo/removeToken');
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, {
        trigger: "hover",
        ref_key: "dropdown",
        ref: dropdown
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          style: {
            "width": "244px",
            "height": "160px",
            "padding": "31px 10px 24px",
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
            class: "ab-center",
            src: _unref(robote),
            alt: "icon"
          }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(phone)), 1)]), _createElementVNode("div", {
            class: "logoutBtn cursor-p",
            onClick: logout
          }, "退出登录")]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          class: "imgOne cursor-p ab-center",
          src: _unref(robote),
          alt: ""
        }, null, 8, _hoisted_4)], 512), [[_vShow, _unref(token) && !_unref(wwToken)]])]),
        _: 1
      }, 512)]), _createElementVNode("div", {
        class: "flex-1"
      }, [_createElementVNode("div", {
        class: "closeImgWrapper cursor-p",
        onClick: close
      })])]);
    };
  }
});